function esNavegadorModerno() {
    try {
        new Function("() => {}");
        return true;
    } catch (e) {
        return false;
    }
}

if (window.location.pathname !== '/') {
    if (!esNavegadorModerno()) {
        document.body.innerHTML = "";
        alert("Tu navegador es demasiado antiguo para soportar esta página. Por favor, actualiza tu navegador.");
        window.location.href = "/";
    }
}



function equivalenciaTallasComprobador() {
    return;
    var tallaEquivalente = document.getElementById('talla_equivalente');
    var addToCartFront = document.querySelector('.product-detail__form__action');
    var errorDiv = document.querySelector('.error-message');
    // errorDiv.innerHTML = 'Seleccione una talla';
    // errorDiv.style.display = 'block';
    var tallaObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                console.log("Talla equivalente actualizada:", tallaEquivalente.value);
                errorDiv.style.display = 'none';
                addToCartFront.style.display = 'inline-flex';
            } else {
              errorDiv.innerHTML = 'La equivalencia de talla es erronea. Por favor, intente con otra talla.';
              errorDiv.style.display = 'block';
              addToCartFront.style.display = 'none';

            }
        });
    });
    tallaObserver.observe(tallaEquivalente, { attributes: true });
}

var tallaSelector = document.getElementById('selector-original-1');

// tallaSelector.addEventListener('change', function() {
//     equivalenciaTallasComprobador();
// });

function doSizesMatch() {

    if (!productHasRealSizeSelector()) return true;

    var sizeSelector = document.getElementById('selector-original-1');
    var countryActive = document.querySelector('.pais-tallas_active');

    if(window.location.pathname.includes('regalo')) {
        return true;
    }

    if (!countryActive) {
        return true;
    }

    var dataVariant = countryActive.getAttribute('data-variant');
    if(sizeSelector.value === dataVariant) {
        return true;
    }

    var options = sizeSelector.options;
    for (var i = 0; i < options.length; i++) {
        if (options[i].value === dataVariant) {
            sizeSelector.selectedIndex = i;
            return true;
        }
    }

    return false;
}


document.addEventListener('DOMContentLoaded', function() {
    // equivalenciaTallasComprobador();

    var addToCartButton = document.getElementById('add-to-cart');
    var addToCartFront = document.querySelector('.product-detail__form__action');
    var errorDiv = document.querySelector('.error-message');
    var page = document.querySelector('.template-product');
    var packProducts = document.querySelectorAll('#shopify-section-packs-product');

    if (addToCartButton && page.classList.contains('template-product') && !packProducts.length) {
        addToCartButton.addEventListener('click', function(event) {

            if (!productHasRealSizeSelector()) return;

            if (!doSizesMatch() || !checkSizesMODDO()) {
                event.preventDefault();
                errorDiv.style.display = 'block';
                errorDiv.innerHTML = 'La talla seleccionada no coincide con la equivalencia.';
            }

        });
    }

    // Add Modal ADD TO CART button Lookbook
    var addToCartButtonLookbook = document.querySelectorAll('.add-to-cart-lookbook');
    if (addToCartButtonLookbook.length) {
        document.querySelectorAll(".add-to-cart-form-lookbook").forEach(form => {
            form.addEventListener("submit", function(event) {
              event.preventDefault();
          
              const formData = new FormData(form);
          
              fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                },
              })
              .then(response => {
                if (!response.ok) {
                  throw new Error('Error al agregar al carrito');
                }
                return response.json();
              })
              .then(data => {
                const thumbUrl = data.image || "";
                const imgAlt = data.title;
                const productTitle = data.title;
                const variantHtml = data.variant_title ? `<p>${data.variant_title}</p>` : '';
                showThemeModal([
                    '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
                    '<div class="inner" style="top: 100px;">', // Puedes ajustar `top` dinámicamente según lo necesites
                    '<a href="#" data-modal-close class="modal-close">&times;</a>',
                    `<h4 id="added-to-cart-title">${theme.icons.tick} ${theme.strings.productAddedToCart}</h4>`,
                    '<div class="cart-product">',
                    `<div class="cart-product__image"><img src="${thumbUrl}" alt="${imgAlt}"/></div>`,
                    '<div class="cart-product__content">' +
                    `<p class="cart-product__content__title">${productTitle}</p>` +
                    `${variantHtml}`,
                    '</div>',
                    '</div>',
                    `<p class="links"><a href="${theme.routes.cart_url}" class="button alt">${theme.strings.viewCart}</a></p>`,
                    '</div>',
                    '</div>'
                ].join(''), "added-to-cart", null);
              })
              .catch(error => {
                console.error('Hubo un problema con la solicitud:', error);
                form.nextElementSibling.innerText = 'Hubo un error al agregar el producto al carrito.';
              });
            });
          });          
    }

    // paisSelector.forEach(function(selector) {
    //     selector.addEventListener('click', function() {
    //         errorDiv.style.display = 'none';
    //         checkSizesMODDO();
    //     });
    // });

    // tallasSelector.forEach(function(selector) {
    //     selector.addEventListener('click', function() {
    //         errorDiv.style.display = 'none';
    //         checkSizesMODDO();
    //     });
    // });

    function checkSizesMODDO() {
        if (!productHasRealSizeSelector()) return true;
        addToCartFront.style.display = 'none';
        errorDiv.style.display = 'none';

        let buttonActive = document.querySelector('.pais-tallas_active');
        if (!buttonActive) {
            return false;
        }

        let idButtonActive = buttonActive.getAttribute('id') || '';
        idButtonActive = idButtonActive.replace('size-', '').replace('-', '.').trim();

        let tallaEquivalenteElement = document.getElementById('talla_equivalente');
        if (!tallaEquivalenteElement) return false;
        
        let tallaEquivalente = tallaEquivalenteElement.value.trim();
        let idButtonActiveValue = buttonActive.textContent.replace(/\s+/g, ' ').trim();

        if (idButtonActiveValue === 'UN ' || idButtonActiveValue === 'UN. ') {
            idButtonActiveValue = idButtonActiveValue.trim();
        }

        let paisTallaActiva = document.querySelector('.pais-active').textContent.trim();
        idButtonActiveValue = `${paisTallaActiva} ${idButtonActiveValue}`.trim();

        let tallaSeleccionada = document.getElementById('selector-original-1').selectedOptions[0].textContent
            .replace('size-', '').replace('-', '.').trim();
        
        let tallaIDSeleccionada = buttonActive.getAttribute('id')
            .replace('size-', '').replace('-', '.').trim();

        console.log('Talla equivalente:', tallaEquivalente);
        console.log('Talla seleccionada:', tallaSeleccionada);
        console.log('Talla ID seleccionada:', tallaIDSeleccionada);
        console.log('Talla activa:', idButtonActiveValue);
        if(tallaEquivalente == 'Tarjeta Regalo') {
            addToCartFront.style.display = 'inline-flex';
            return true;
        }

        if (idButtonActiveValue === tallaEquivalente && tallaSeleccionada === tallaIDSeleccionada) {
            addToCartFront.style.display = 'inline-flex';
            return true;
        } else {
            errorDiv.style.display = 'block';
            errorDiv.innerHTML = 'La talla seleccionada no coincide con la equivalencia.';
            return false;
        }
    }
});


function productHasRealSizeSelector() {
    const select = document.querySelector('[name="id"]');
    if (!select) return false;
    return select.options.length > 1;
}
